import {z} from 'zod';

import i18n from '@dms/i18n';

import {
  AccountingMatrixDatagridConfig,
  getAccountingMatrixDatagridSharedFields,
} from '../../utils/accountingMatrixDatagridConfig';

/**
 * Only `invoiceSeries` is in the swagger's `required` list, but M205/Operation Items both
 * turned out to have NOT NULL DB columns BE doesn't validate at the API layer (T20-137885/
 * T20-137887) — the rest are made required here as a precaution too. Relax any back to
 * optional if BE confirms they're actually nullable.
 */
export const getAccountingMatrixDatagridM201InvoicesConfig =
  (): AccountingMatrixDatagridConfig => ({
    dgCode: 'm201-invoices',
    fields: [
      {
        name: 'invoiceSeries',
        label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldInvoiceSeries'),
        type: 'text',
        isRequired: true,
      },
      {
        name: 'seriesName',
        label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldSeriesName'),
        type: 'text',
        isRequired: true,
      },
      {
        name: 'centre',
        label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldCentre'),
        type: 'text',
        isRequired: true,
      },
      {
        name: 'debitAccount',
        label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldDebitAccount'),
        type: 'text',
        isRequired: true,
      },
      {
        name: 'debitAccountForeignCurrency',
        label: i18n.t(
          'page.accounting.labels.accountingMatrixDatagridsFieldDebitAccountForeignCurrency'
        ),
        type: 'text',
        isRequired: true,
      },
      {
        name: 'documentText',
        label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldDocumentText'),
        type: 'text',
        isRequired: true,
      },
      ...getAccountingMatrixDatagridSharedFields(),
    ],
    schema: z.object({
      invoiceSeries: z.string().min(1),
      seriesName: z.string().min(1),
      centre: z.string().min(1),
      debitAccount: z.string().min(1),
      debitAccountForeignCurrency: z.string().min(1),
      documentText: z.string().min(1),
      billingInformation: z.string().min(1),
      validFrom: z.string(),
      validTo: z.string(),
    }),
  });
